import { render, staticRenderFns } from "./ProcedenciaComponent.vue?vue&type=template&id=8e7140ec"
import script from "./ProcedenciaComponent.vue?vue&type=script&lang=js"
export * from "./ProcedenciaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports